const types = {
  CLEAR_CURRENT: 'INITIATIVES_CLEAR_CURRENT',
  GET_REQUEST: 'INITIATIVES_GET_REQUEST',
  GET_SUCCESS: 'INITIATIVES_GET_SUCCESS',
  GET_FAILURE: 'INITIATIVES_GET_FAILURE',

  SAVE_REQUEST: 'INITIATIVES_SAVER_REQUEST',
  SAVE_SUCCESS: 'INITIATIVES_SAVE_SUCCESS',
  SAVE_FAILURE: 'INITIATIVES_SAVE_FAILURE',

  GETALL_REQUEST: 'INITIATIVES_GETALL_REQUEST',
  GETALL_SUCCESS: 'INITIATIVES_GETALL_SUCCESS',
  GETALL_FAILURE: 'INITIATIVES_GETALL_FAILURE',

  DELETE_REQUEST: 'INITIATIVES_DELETE_REQUEST',
  DELETE_SUCCESS: 'INITIATIVES_DELETE_SUCCESS',
  DELETE_FAILURE: 'INITIATIVES_DELETE_FAILURE',    

  UPDATE_REQUEST: 'INITIATIVES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'INITIATIVES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'INITIATIVES_UPDATE_FAILURE'    

};

export default types;